import {
    SEARCHFILTER, SearchFilterDataAction, searchFilterData
} from './types';

export const searchFilter = (filter: searchFilterData): SearchFilterDataAction => {
    return {
        type: SEARCHFILTER.SEARCH_FILTER_DATA,
        payload: filter
    };
}